import { render, staticRenderFns } from "./AddEditQuote.vue?vue&type=template&id=123adde0&scoped=true"
import script from "./AddEditQuote.vue?vue&type=script&lang=js"
export * from "./AddEditQuote.vue?vue&type=script&lang=js"
import style0 from "./AddEditQuote.vue?vue&type=style&index=0&id=123adde0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123adde0",
  null
  
)

export default component.exports